import React, { Component } from 'react'
import AddressValidationTest from './AddressValidationTest'

export class ParentPage extends Component {
    state = {
        boop: undefined
    }

    cancel = () => {
		this.setState({ boop: undefined });
    };
    
    changeBoop = () => {
        this.setState({ boop: "beep"});
    }


    render() {
        return (
            <div>
                <button className="admin-k-button" onClick={this.changeBoop}>
                    <span>OPEN FORM</span>
                </button>
                {this.state.boop && (
						<AddressValidationTest
							cancel={this.cancel}
						/>
					)}
            </div>
        )
    }
}

export default ParentPage
